export const getErrorMessage = (addToWalletErrorCode: number) => {
  if (addToWalletErrorCode === 500) {
    return 'We ran into an issue, please try adding to your wallet again';
  }
  if (addToWalletErrorCode === 400 || addToWalletErrorCode === 401) {
    return 'This coupon may have already been redeemed, please refresh the page and try again';
  }
  if (addToWalletErrorCode === 404) {
    return 'This coupon cannot be added to wallet currently. Please try again later.';
  } else {
    return 'There was an error retrieving add to wallet link';
  }
};
